import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardTable from '../../../../../../components/DashboardTable';
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";
import {TRADING_ACTION_BUY, TRADING_ACTION_SELL} from "../../../../../../components/Charts/InstrumentsAllocationTable/constants";
import ConfirmationHeader from "./components/ConfirmationHeader";
import {
  singleInvestmentConfirmationTableStructure, singleInvestmentConfirmationTableStructureEinzeltitel,
  singleInvestmentConfirmationTableStructureForMP
} from "./components/confirmationTableColumns";
import useStyles, {useEinzeltitelStyles} from "./components/singleInvestmentTableStyles";
import {splitEinzeltitelTradingInstruments} from "../../../../../RiskProfiling/utils";

const addOrderNumber = (allItems) => {
  let orderNumber = 1;
  allItems.forEach(item => {
    if (!item.isSwitchInItem) {
      item._orderNumber = orderNumber++;
    }
  });
}
/**
 * Prepare flat list of transactions with order numbers for the confirmation table.
 * Switch-out items are numbered; switch-in items are nested under their parent.
 */
const prepareTransactions = (transactions) => {
  const buy = (transactions[TRANSACTION_TYPE_VALUES.BUY] || []).map(item => ({
    ...item,
    tradingType: TRADING_ACTION_BUY,
  }));
  const sell = (transactions[TRANSACTION_TYPE_VALUES.SELL] || []).map(item => ({
    ...item,
    tradingType: TRADING_ACTION_SELL,
  }));

  // For switch: flatten switch-out + switch-in items
  const switchItems = [];
  (transactions[TRANSACTION_TYPE_VALUES.SWITCH] || []).forEach(switchOut => {
    switchItems.push({
      ...switchOut,
      isSwitchOutItem: true,
      tradingType: TRADING_ACTION_SELL,
    });
    (switchOut.buy || []).forEach(switchIn => {
      switchItems.push({
        ...switchIn,
        tradingType: TRADING_ACTION_BUY,
        isSwitchInItem: true,
        switchOutItem: switchOut,
      });
    });
  });

  const allItems = [...buy, ...sell, ...switchItems];

  addOrderNumber(allItems)

  return allItems;
};


/**
 * Displays the single investment (buy/sell/switch) transactions for a single portfolio
 * as a read-only confirmation table.
 */
function SingleInvestmentStep(props) {
  const {
    questions: [question],
    dataService,
  } = props;

  const classes = useStyles();
  const einzeltitelClasses = useEinzeltitelStyles();

  const portfolio = question.portfolio;

  if (!portfolio) {
    return null;
  }

  const dataSource = React.useMemo(
    () => prepareTransactions(portfolio.transactions),
    [portfolio.transactions]
  );

  let nonFunds = [], funds = [];
  if(portfolio.isModelportfolio){
    funds = dataSource;
  } else {
    splitEinzeltitelTradingInstruments(dataSource, portfolio.available_asset_classes, nonFunds, funds);

    // re-order
    addOrderNumber(funds)
    addOrderNumber(nonFunds)
  }

  const tableOptions = React.useMemo(() => ({
    maxQtyDecimals: portfolio.maxQtyDecimals,
    isModelportfolio: portfolio.isModelportfolio,
    modelPortfolioTransactionType: portfolio.modelPortfolioTransactionType,
    combinedDiscounts: portfolio.combinedDiscounts,
    depotDiscount: portfolio.discount,
  }), [portfolio]);

  const hasEinzeltitel = nonFunds.length > 0;

  return (
    <Grid container spacing={3}>
      <ConfirmationHeader stepName={dataService.step.category} />
      {funds.length > 0 && (
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasEinzeltitel && (
              <Grid item xs={12} className={classes.tableHeader}><b>Einzelfonds/Musterdepots</b></Grid>
            )}
            <Grid item xs={12} className={classes.tableContainer}>
              <DashboardTable
                tableLayout={"auto"}
                structure={portfolio.isModelportfolio ? singleInvestmentConfirmationTableStructureForMP : singleInvestmentConfirmationTableStructure}
                dataSource={funds}
                expanded
                tableClasses={classes}
                withFooter
                options={tableOptions}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      {hasEinzeltitel && (
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} className={classes.tableHeader}><b>Einzeltitel/Aktien</b></Grid>
            <Grid item xs={12} className={classes.tableContainer}>
              <DashboardTable
                tableLayout={"auto"}
                structure={singleInvestmentConfirmationTableStructureEinzeltitel}
                dataSource={nonFunds}
                expanded
                tableClasses={einzeltitelClasses}
                withFooter
                options={tableOptions}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default SingleInvestmentStep;
